var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-sans antialiased leading-tight p-0 xs:-mr-5 w-full overflow"},[_c('app-header'),_c('app-features'),_c('app-download'),_c('app-testimonials'),_c('app-contact'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }